import { render, staticRenderFns } from "./DiamondIcon.vue?vue&type=template&id=7e4f0a3a&"
import script from "./DiamondIcon.vue?vue&type=script&lang=js&"
export * from "./DiamondIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports